import { uniq, cloneDeep, merge } from "lodash-es";

export function upsertEntities<T extends { id: string }>(entities: T[], store: any) {
  const ids = entities.map((entity) => entity.id);
  const prev = store.entities as { [id: string]: T };
  const next: { [id: string]: T } = { ...prev };
  ids.forEach((id, index) => {
    next[id] = merge({}, prev[id], entities[index]) as T;
  });
  store.ids = uniq(store.ids.concat(ids));
  store.entities = next;
}

export function removeEntity<T extends { id: string }>(entity: T, store: any) {
  const ids = (store.ids as string[]).filter((entityId) => entityId !== entity.id);
  const entities = cloneDeep(store.entities) as { [id: string]: T };
  delete entities[entity.id];
  store.ids = ids;
  store.entities = entities;
}

export function replaceCollection<T extends { id: string }>(entities: T[], store: any) {
  const ids = entities.map((entity) => entity.id);
  const e = ids.reduce((acc: any, id, index) => {
    acc[id] = entities[index];
    return acc;
  }, {}) as { [id: string]: T };
  store.ids = uniq(ids);
  store.entities = e;
}

export function removeByProp<T extends { id: string }>(
  propName: string,
  propValue: any,
  store: any,
) {
  const ids = store.ids.filter(
    (id: string) => store.entities[id][propName] !== propValue,
  ) as string[];
  const e = ids.reduce((acc: any, id) => {
    acc[id] = store.entities[id];
    return acc;
  }, {}) as { [id: string]: T };
  store.ids = uniq(ids);
  store.entities = e;
}
